import Validator from 'validatorjs';
import { qaResponse } from './rules';

const validateQaResponse = (values) => {
  const validation = new Validator(values, qaResponse);
  validation.setAttributeNames({
    responseNotes: 'Response Notes'
  });
  if (validation.passes()) {
    return {};
  } else {
    return validation.errors.all();
  }
};

export {
  validateQaResponse
};